import { applyMiddleware, createStore } from 'redux';
import ReduxThunk from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { composeWithDevTools } from '@redux-devtools/extension';
import { rootReducer } from './reducers';

const persistConfig = {
  key: 'root',
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
const store = createStore(
  persistedReducer,
  composeWithDevTools(applyMiddleware(ReduxThunk)),
);

const persistor = persistStore(store);
export { store, persistor };

// const store = createStore(persistedReducer,compose( applyMiddleware(ReduxThunk));

// compose(applyMiddleware(thunk), window.__REDUX_DEVTOOLS_EXTENSION__ && window.
// __REDUX_DEVTOOLS_EXTENSION__())
